// extracted by mini-css-extract-plugin
export var button = "_65-4";
export var hasDarkBackground = "_65-7";
export var hasLightBackground = "_65-6";
export var iconWrapper = "_65-0";
export var large = "_65-2";
export var medium = "_65-1";
export var small = "_65-5";
export var xsmall = "_65-3";